// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { processKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import { getProcessMapContract, type GetProcessMapResponse } from '@bliks-io/contracts';

// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated

/** Fetches the full process landscape map (nodes, edges, summary KPIs). */
export function useProcessMap({ enabled = true }: { enabled?: boolean } = {}) {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: processKeys.map(),
    queryFn: async ({ signal }): Promise<GetProcessMapResponse['data']> => {
      const { data } = await apiClient.get<GetProcessMapResponse>(getProcessMapContract.path, {
        signal
      });
      return data.data;
    },
    enabled: !!token && enabled,
    staleTime: 5 * 60 * 1000 // 5 min cache
  });
}
